const APPLICATION_STEP_PATHS: Record<string, string> = {
  review: '/driver-application/review',
}

export const LOGIN_ONLY_PARAMS = ['slug', 's', 'redirectTo']

export const isDriverStep = (step?: string | null): boolean =>
  Boolean(step && step in APPLICATION_STEP_PATHS)

export const applicationPathForStep = (step?: string | null): string =>
  APPLICATION_STEP_PATHS[step ?? ''] ?? '/driver-application'

export const companyDriverPath = (
  companySlug: string,
  step?: string | null
): string =>
  `/c/${encodeURIComponent(companySlug)}${
    isDriverStep(step) ? `/${step}` : ''
  }`

export const forwardQuery = (
  search: string,
  set: Record<string, string | undefined> = {},
  drop: string[] = []
): string => {
  const params = new URLSearchParams(search)
  drop.forEach((key) => params.delete(key))
  Object.entries(set).forEach(([key, value]) => {
    if (value) params.set(key, value)
  })
  const query = params.toString()
  return query ? `?${query}` : ''
}
